import { toast  } from 'react-toastify';
import moment from 'moment';

import 'react-toastify/dist/ReactToastify.min.css';
//import MapsPinDrop from 'material-ui/SvgIcon';
//import { AlertTriangle } from 'react-feather';

// http://localhost:8000/api

//const API = "https://www.impacttournaments.com/api";
const API = process.env.REACT_APP_API_URL;
const HEREAPIKEY = process.env.REACT_APP_HEREAPIKEY;
//const PM = process.env.REACT_APP_PRIME_MEMBERSHIP;
const SENDRESETCODE_TEMPLATE = process.env.REACT_APP_SENDRESETCODE_TEMPLATE;
const SENDCREATECODE_TEMPLATE = process.env.REACT_APP_SENDCREATECODE_TEMPLATE;

export const isProtected = (obj) => {
    return obj && obj['permTags'] && obj['permTags'].includes("MEMBERSHIP")
}

function buildSort(qIn) {
    if (!qIn) return "";
    
    const qSortBy = qIn.sortBy ? `&sortBy=${qIn.sortBy}` : "";
    const qOrder = qIn.order ? `&order=${qIn.order}` : "";
    const qLimit = qIn.limit ? `&limit=${qIn.limit}` : "";
    const qTag = qIn.tag ? `&tag=${qIn.tag}` : "";
    const qSourceId = qIn.sourceId ? `&sourceId=${qIn.sourceId}` : "";
    const qOut = "?"+(qSortBy + qOrder + qLimit + qTag + qSourceId).substring(1);

    if (qOut === "?") return "";
    else return qOut;
}

function callAPI(command, method, body, sorts, headers) {
    const { user, token } = AuthenticatedUser();
    var myHeaders = headers ? headers : new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});

    return fetch(`${API}/${command}/${user._id}${buildSort(sorts)}`, {
        method: method?method:'GET',
        headers: myHeaders,
        body: body
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        return err;
    })
}

export const callGEOCode = (locationId, address) => {
    var url = `https://geocoder.ls.hereapi.com/6.2/geocode.json?apiKey=${HEREAPIKEY}&`;

    if (locationId.length > 0) {
      url += `locationId=${locationId}`
    } else {
      url += `searchtext=${address}`
    }
    
    return fetch(url)
    .then(function (response) {
        return response.json();
    })
    .catch(function (error) {
        console.log('caught failed query');
    });
}

export const getTournamentValues = (t, roomId) => {
    var tRoom = null;
    var rEvent = null;
    var tRound = null;
    for(var i=0; i< t.rounds.length; i++) {
        const round = t.rounds[i];
        for(var j=0; j < round.events.length; j++) {
            const event = round.events[j];
            if (!tRoom) {
                tRoom = event.rooms.find(x=>x._id === roomId);
                if (tRoom) {
                    rEvent = event;
                    tRound = round;
                }
            }
        }
    } 
    
    return {tRound, rEvent, tRoom}
}

export const callGEOAutoComplete = (query, maxresults) => {
    var url = `https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json?apiKey=${HEREAPIKEY}&`;
    url += `query=${query}&maxresults=${maxresults}`;

    return fetch(url)
    .then(response => {
        return response.json();      
    })
    .catch(function (error) {
        console.log('caught failed autocomplete');
    });
}

function callJsonAPI(command, method, body, sorts)  {
    const { token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');
    return callAPI(command, method, body?JSON.stringify(body):null, sorts, myHeaders);
};

function newCallJsonAPI(command, method, body, sorts)  {
    const { token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');
    return callAPI(command, method, body?JSON.stringify(body):null, sorts, myHeaders)
    .then(d2 => {
        if (d2 && d2.error) {
            putToast.error(d2.error); 
            console.log(d2.error);
        } else {
            putToast.success(d2.message)
        }
        return d2;
    })
    .catch(err => {
        putToast.error(err)
        console.log(err);
    })
};

export const getAPI = (command) => { return callJsonAPI(command)}
export const getObject = (type, id) => { return callAPI(`${type}/${id}`) };
export const loadObject = (type, id) => { return callAPI(`${type}/load/${id}`) };
export const loadObjectWith = (type, projection, id) => {  return callAPI(`${type}/load/${projection}/${id}`) };
export const loadPostings = (id) => { return callAPI(`tournamentPage/loadPostings/${id}`)}
export const loadRoom = (id) => { return callAPI(`tournamentPage/loadRoom/${id}`)}
export const loadQuickPostings = (id) => { return callAPI(`tournamentPage/loadQuickPostings/${id}`)}
export const loadAdminConsole = (id) => { return callAPI(`tournamentPage/loadAdminConsole/${id}`)}
export const loadMyBallots = (id) => { return callAPI(`tournamentPage/loadMyBallots/${id}`)}
export const loadRegistration = (id) => { return callAPI(`tournamentPage/loadRegistration/${id}`)}
export const loadJudgeAvailability = (id) => { return callAPI(`tournamentPage/loadJudgeAvailability/${id}`)}
export const loadJudgeConflicts = (id, userId) => { return callAPI(`tournamentPage/loadJudgeConflicts/${id}/${userId}`) }; 

export const loadBallot = (tid, rmid, jid, cid) => { return callAPI(`ballot/load/${tid}/${rmid}/${jid}/${cid}`) };    
export const adminloadTP = (func, projection, id) => {  return callAPI(`tournamentPage/adminload/${func}/${projection}/${id}`) };

export const loadPromptStatus = (tid, rndid, eid, rmid, cid) => { 
    return callAPI(`rercPromptStatus/findload/${tid}/${rndid}/${eid}/${rmid}/${cid}`) 
};
export const getObjects = (type, route, filter, sorts) => { 
    var url = `${type}s`;
    if (route) { url += `/${route}` }

    return callJsonAPI(url, 'POST', filter, sorts) 
};
export const createObject = (type) => { 
    return callAPI(`${type}/create`, 'PUT');
};
export const updateObject = (type, object, id) => { 
    return callAPI(`${type}/update/${id?id:0}`, 'PUT', object);
};
export const reviseObject = (type, revision, id) => { return callAPI(`${type}/revise/${id}`, 'POST', revision )};
export const deleteObject = (type, id) => { return callAPI(`${type}/${id}`, 'DELETE'); };
export const duplicateObject = (type, id) => { return callAPI(`${type}/duplicate/${id}`, 'PUT'); };

export const loadMenu = (menuId) => { return callAPI(`menu/load/${menuId}`); };
export const loadPage = (pageId) => { return callAPI(`page/load/${pageId}`); };
export const loadLandingPage = (landingPageId) => { return callAPI(`landingPage/load/${landingPageId}`); };
export const loadDashboard = (userId) => { return callAPI(`user/dashboard/${userId}`); };
export const loadCart = (userId) => { return callAPI(`user/cart/${userId}`); };
export const computeCartFull = (userId, coupons) => { return callAPI(`user/cartCompute/${coupons}/${userId}`); };

export const reviseUser = (values, userId) => { 
    return callJsonAPI(`user/revise/${userId}`, 'POST', { values: values } )
};

export const newReviseUser = (values, userId) => { 
    return newCallJsonAPI(`user/revise/${userId}`, 'POST', { values: values } )    
};

export const updateBallot = (tournamentId, values, ballotId) => { 
    return callJsonAPI(`ballot/update/${tournamentId}/${ballotId}`, 'POST', { values: values } )
};

export const avatarUrl = (id) => {
    const { user } = AuthenticatedUser();

    return `${API}/user/avatar/${id}/${user._id}`                
}

// tournament revisions
export const tournamentAddEvent = (values, tournamentId) => { 
    return callAPI(`tournamentPage/addEvent/${tournamentId}`, 'POST', values  )
};

export const tournamentAddRoundEvent = (values, tournamentId, roundId) => { 
    return callAPI(`tournamentPage/addRoundEvent/${tournamentId}/${roundId}`, 'POST', values  )
};

export const tournamentUpdateEvent = (values, eventId, tournamentId) => { 
    return callAPI(`tournamentPage/updateEvent/${tournamentId}/${eventId}`, 'POST', values  )
};

export const tournamentUpdateRoundEvent = (values, eventId, roundId, tournamentId) => { 
    return callAPI(`tournamentPage/updateRoundEvent/${tournamentId}/${roundId}/${eventId}`, 'POST', values  )
};

export const tournamentRemoveEvent = (eventId, tournamentId) => { 
    return callJsonAPI(`tournamentPage/removeEvent/${tournamentId}/${eventId}`, 'POST' )
};

export const tournamentRemoveRoundEvent = (eventId, roundId, tournamentId) => { 
    return callJsonAPI(`tournamentPage/removeRoundEvent/${tournamentId}/${roundId}/${eventId}`, 'POST' )
};

export const tournamentAddRound = (values, tournamentId) => { 
    return callAPI(`tournamentPage/addRound/${tournamentId}`, 'POST', values  )
};

export const tournamentUpdateRound = (values, roundId, tournamentId) => { 
    return callAPI(`tournamentPage/updateRound/${tournamentId}/${roundId}`, 'POST', values  )
};

export const tournamentRemoveRound = (roundId, tournamentId) => { 
    return callJsonAPI(`tournamentPage/removeRound/${tournamentId}/${roundId}`, 'POST' )
};

// Prompts

export const revealPrompts = (competitorId, reRoomId, rEventId, tRoundId, tournamentId) => { 
    return callJsonAPI(`rercPromptStatus/reveal/${tournamentId}/${tRoundId}/${rEventId}/${reRoomId}/${competitorId}`, 'PUT' )
};

export const offerPrompts = (id) => { 
    return callJsonAPI(`rercPromptStatus/offer/${id}`, 'PUT' )
};

export const selectPrompts = (id, index) => { 
    return callJsonAPI(`rercPromptStatus/select/${id}/${index}`, 'PUT' )
};



export const saveAvatar = (id, avatar) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/user/reviseAvatar/${id}/${user._id}`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({avatar: avatar})
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}

export const reviseJudgeConflict = (tournamentId, judgeId, competitorId, values) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = values;

    return fetch(`${API}/reviseJudgeConflict/${tournamentId}/${judgeId}/${competitorId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        toast.error(err);
    })

};

export const runService = (service, command, serviceId, tournamentId, userId='0') => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/${service}/${command}/${serviceId}/${tournamentId}/${userId}/${user._id}`, {
        method: 'GET',
        headers: myHeaders
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        toast.error(err);
    })

};

export const downloadBallots = (tournamentId, userId='0') => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/pdf", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/downloadBallots/${tournamentId}/${userId}/${user._id}`, {
        method: 'GET',
        headers: myHeaders
    })
    .then(response => {
        return response
    })
    .catch(err => {
        console.log(err);
        //toast.error(err);
    })

};

export const downloadCerts = (tournamentId, userId='0') => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/pdf", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/downloadCerts/${tournamentId}/${userId}/${user._id}`, {
        method: 'GET',
        headers: myHeaders
    })
    .then(response => {
        return response
    })
    .catch(err => {
        console.log(err);
        //toast.error(err);
    })

};

export const resolveAlert = (alert, val) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {values: {isResolved: val}};

    return fetch(`${API}/resolveAlert/${alert.alertId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        toast.error(err);
    })

};

export const reviseTUser = (tUser) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {values: tUser};

    return fetch(`${API}/reviseTUser/${tUser.tournamentId}/${tUser.userId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        toast.error(err);
    })

};


export const reviseTournamentPage = (id, values) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/tournamentPage/revise/${id}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: values
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        toast.error(err);
    })

};


export const reviseTUserAcceptRoom = (tUser) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {values: tUser};

    return fetch(`${API}/reviseTUserAcceptRoom/${tUser.tournamentId}/${tUser.userId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        toast.error(err);
    })

};

export const getCurrentAssignment = (tUser) => {
    if (tUser && tUser.rounds) {
        for(const tUserRound of tUser.rounds) {
            for(const tUserRoundEvent of tUserRound.events) {
                for(const tUserRoundEventRoom of tUserRoundEvent.rooms) {
                    if (tUserRoundEventRoom.hasAccepted && !tUserRoundEventRoom.hasCompleted) return tUserRoundEventRoom;
                }
            }
        }
    }

    return null;
}


export const hasCompletedRoomForRound = (tUser, roundId) => {
    if (!tUser.isJudge) return false;

    if (tUser && roundId && tUser.rounds) {
        for(const tUserRound of tUser.rounds) {
            if (tUserRound.roundId === roundId) {
                for(const tUserRoundEvent of tUserRound.events) {
                    for(const tUserRoundEventRoom of tUserRoundEvent.rooms) {
                        if (tUserRoundEventRoom.hasCompleted) return true;
                    }
                }
            }
        }
    }

    return false;
}

export const isAssignedRoom = (tUser, round, event, room) => {
    if (!tUser.isJudge) return false;

    if (tUser && round && event && room && tUser.rounds) {
        const tUserRound = tUser.rounds.find(x=>x.roundId === round._id);
        const tUserRoundEvent = tUserRound.events.find(x=>x.eventId === event.eventId)
        const tUserRoundEventRoom = tUserRoundEvent.rooms.find(x=>x.roomId === room._id)
        
        if (!tUserRoundEventRoom) return false;
        
        // if there is a slot and judge is assigned
        if (room.judges && room.judges.length < event.requiredJudgeCount) {
            return tUserRoundEventRoom.isAssigned
        }
    }
    return false;
}

export const isAssignedEvent = (tUser, round, event) => {
    if (!tUser.isJudge) return false;

    if (tUser && round && event && tUser.rounds) {
        const tUserRound = tUser.rounds.find(x=>x.roundId === round._id);
        const tUserRoundEvent = tUserRound.events.find(x=>x.eventId === event.eventId)
        for(const tUserRoundEventRoom of tUserRoundEvent.rooms) {
            if (tUserRoundEventRoom.isAssigned) return(true);
        }
    }
    return false;
}

export const isAssignedRound = (tUser, round) => {
    if (!tUser.isJudge) return false;

    if (tUser && round && tUser.rounds) {
        const tUserRound = tUser.rounds.find(x=>x.roundId === round._id);
        if(tUserRound) {
            for(const tUserRoundEvent of tUserRound.events) {
                if (tUserRoundEvent.isAssigned) return(true);
                for(const tUserRoundEventRoom of tUserRoundEvent.rooms) {
                    if (tUserRoundEventRoom.isAssigned) return(true);
                }
            }
        }
    }
    return false;
}

export const setRoundAvailable = (round, value) => {
    round.isAvailable = value;
    for(const tUserRoundEvent of round.events) {
        tUserRoundEvent.isAvailable = value;
    }
}

export const setEventAvailable = (round, event, value) => {
    if (value) {
        round.isAvailable = true;
        event.isAvailable = true;
        return;
    }
    event.isAvailable = false;
}

export const setRoomAccepted = ( room, value) => {
    if (value) {
        room.hasAccepted = true;
        return;
    }
    room.hasAccepted = false;
    room.isAssigned = false;
    room.isAvailable = false;
}
export const getTournamentFinances = (tUser) => {
    const owes = (tUser && tUser.events) ? tUser.events.filter(x=>x.isRegistered && !x.isPaid).reduce((a,b) => a + (b.fee || 0), 0) : 0;
    const paid = (tUser && tUser.events) ? tUser.events.filter(x=>x.isRegistered && x.isPaid).reduce((a,b) => a + (b.fee || 0), 0) : 0;
    return { owes, paid }
}

function createStatus(tUserEvent) {
    if (tUserEvent && tUserEvent.isRegistered) {
        if (!(tUserEvent.isPaid && tUserEvent.isPartnered)) {
            const reasons = [];

            if (!tUserEvent.isPaid) reasons.push("Payment");
            if (!tUserEvent.isPartnered) reasons.push("Partner");

            return `Waiting: ${reasons.join(", ")}`;
        } else return "Ready!"
    } 
    
    return "Not Registered"
}

export const createRegistrationStatus = (tUserEvent) => {
    return createStatus(tUserEvent)
}
/*
export const createAgRegistrationStatus = (tUser) => {
    // propagate down the list of success - ready, pending, not reg
    if (!tUser || !tUser.events) return "New"
    if (tUser && !tUser.isRegistered) return "Not Registered"
    var status = "Ready!";

    for(const tUserEvent of tUser.events) {
        const newStatus = createStatus(tUserEvent);
        if (newStatus.startsWith("Waiting") || newStatus === 'Not Registered') {
            if (status.startsWith("Waiting") || status === 'Ready!') status = newStatus;
        }
    }

    if (!tUser.isDesignationComplete || !tUser.isAvailableComplete) {
        if (status === 'Ready!') status = "Waiting"
        if (status.startsWith("Waiting")) status += " - Judge ";
    }

    return status;
}
*/
export const getCurrentRound = (tournament) => {
    if (tournament && tournament.rounds) {
        return tournament.rounds.find(x=>x.status === 'released' || x.status === 'posted')
    }
    return null;
}

export const sendTournamentMailByContent = (tournamentId, template, subject, content, recipientGroup, eventId, sources, recipJ) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {template: template, subject: subject, content: content, recipientGroup: recipientGroup, eventId: eventId, sources: sources, recipJ: recipJ };

    return fetch(`${API}/sendTournamentMail/${tournamentId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => { response.json()
    .then(data => {
            toast.success(data.message);
        })
    })
    .catch(err => {
        console.log('failure to send');
        toast.error(err);
    })
};


export const sendMailById = (templateId, recipientIds, sources) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {recipientIds: recipientIds, sources: sources };

    return fetch(`${API}/sendMail/${templateId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => { response.json()
    .then(data => {
            toast.success(data.message);
        })
    })
    .catch(err => {
        console.log('failure to send');
        toast.error(err);
    })
};

export const refreshStatus = (tpId) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/refreshStatus/${tpId}/${user._id}`, {
        method: 'GET',
        headers: myHeaders
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        toast.error(err);
    })

};

export const resetPassword = (values) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/user/resetPassword/${user._id}`, {
        method: 'PUT',
        headers: myHeaders,
        body: JSON.stringify(values)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log('failure to send');
        toast.error(err);
    })
};


export const sendForgotCode = (email) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {email: email, recipientIds: ["1"] };

    return fetch(`${API}/sendMail/${SENDRESETCODE_TEMPLATE}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => { 
        return response.json();
    })
    .catch(err => {
        console.log('failure to send');
        toast.error(err);
    })
};


export const sendCreateAccountCode = (email) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {email: email, recipientIds: ["1"] };

    return fetch(`${API}/sendMail/${SENDCREATECODE_TEMPLATE}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => { 
        return response.json();
    })
    .catch(err => {
        console.log('failure to send');
        toast.error(err);
    })
};

export const sendMail = (values) => { 
    return callJsonAPI(`sendMail`, 'POST', { message: values } )
    .then(response => {
        toast.success("Message Sent");
    })
    .catch(function (error) {
        console.log('failure to send');
    });

};

// tournaments
export const buildRound = (tournamentId) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {something: 7 };

    return fetch(`${API}/buildRound/${tournamentId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log("buildRound-err:", err);
        toast.error(err);
    })
};
export const postRound = (tournamentId) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {something: 7 };

    return fetch(`${API}/postRound/${tournamentId}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log("postRound-err:", err);
        toast.error(err);
    })
};

export const setRound = (tournamentId, newState) => { 
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    const body = {something: 7 };
    return fetch(`${API}/tournament/round/state/${tournamentId}/${newState}/${user._id}`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log("setRound-err:", err);
        toast.error(err);
    })
};

export const postComment = (realmItem, targetId, comment) => { return callAPI(`comment/${realmItem}/${targetId}`, 'POST', comment ); }

export const setDataMembership = (id, name, value) => {callJsonAPI(`setMembership/${id}`, 'PUT', {primeMembership: {prefName: name, prefValue: value}}); }
export const setDataPreference = (id, name, value) => {callJsonAPI(`setPreference/${id}`, 'PUT', {preference: {prefName: name, prefValue: value}}); }
export const setPreference = (name, value) => { 
    const jwt = AuthenticatedUser();
    if (!jwt.user.preferences) { jwt.user.preferences = {} }

    jwt.user.preferences[name] = value;

    authenticate(jwt, () => {
        callJsonAPI(`setPreference/${jwt.user._id}`, 'PUT', {preference: {prefName: name, prefValue: value}});
    });
}
export const setPerm = (value, user) => { 
    const jwt = AuthenticatedUser();
    if (!jwt.user.permissions) { jwt.user.permissions = [] }

    jwt.user.permissions.push(value);

    authenticate(jwt, () => {
    });

    if (user) {
        if (!user.permissions) { user.permissions = [] }
        user.permissions.push(value);  
        return user;      
    }
}

export const removePerm = (value) => { 
    const jwt = AuthenticatedUser();
    
    if (!jwt.user.permissions) { return }

    const index = jwt.user.permissions.indexOf(value);
    if (index > -1) {
        jwt.user.permissions.splice(index, 1);
    }  

    authenticate(jwt, () => {
    });
}

export const addToFilter = (filter, filterPart) => {
    for (let key in filterPart) {
        if (filterPart[key].length > 0) {
            filter[key] = filterPart[key];
        }
    }
}

export const getListedObjects = (type, list, sorts, cb, timeout) => {
    fetch(`${API}/${type}s/by/list${buildSort(sorts)}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(list)
        })
        .then(res => res.json())
        .then(ps => {
            cb(ps);
        })
    }

    export const formatDate = (date) => {
        if (!date) return "";

        var monthNames = [
          "January", "February", "March",
          "April", "May", "June", "July",
          "August", "September", "October",
          "November", "December"
        ];
      
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
      
        if (!day) return "";
        if (year < 1970) return "";
        return day + ' ' + monthNames[monthIndex] + ' ' + year;
      }
      
          
    export const formatShortDate = (date) => {
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
      
        if (!day) return "";
        return `${monthIndex+100}/`.substring(1) + `${day+100}/`.substring(1) + `${year}`
        
      } 

    export const formatTime = (date) => {
        var seconds = date.getSeconds();
        var minutes = date.getMinutes();
        var hours = date.getHours();
        var meridian = hours >= 12 ? 'PM' : 'AM'
        hours = hours > 12 ? hours - 12 : hours

        return `${hours}:` + `${minutes+100}:`.substring(1) + `${seconds+100}`.substring(1) + ` ${meridian}` ; //${tz>0?'+':'-'}${tz/60}
    }
      
  export const formatDateTime = (date) => {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];
  
    var seconds = date.getSeconds();
    var minutes = date.getMinutes();
    var hours = date.getHours();
    
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

  
    if (!day) return "";
    return `${day} ${monthNames[monthIndex]} ${year}  ` +  `${hours+100}:`.substring(1) + `${minutes+100}:`.substring(1) + `${seconds+100}`.substring(1) ; //${tz>0?'+':'-'}${tz/60}
  }

    export const toTitleCase = (string) => {
        var sentence = string.toLowerCase().split(" ");
        for(var i = 0; i< sentence.length; i++){
            sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
        }
        return sentence;
    } 

  export const formatSuperShortDateTime = (date) => {
    var minutes = date.getMinutes();
    var hours = date.getHours();
    var meridian = hours >= 12 ? 'PM' : 'AM'
    hours = hours >= 12 ? hours - 12 : hours

    var day = date.getDate();
    var monthIndex = date.getMonth()+1;
  
    if (!day) return "";
    return `${monthIndex}/${day}  ${hours}:` + `${minutes+100}`.substring(1) + ` ${meridian}`
  }
  
    export const fieldSorter = (fields) => (a, b) => fields.map(o => {
        let dir = 1;
        if (o[0] === '-') { dir = -1; o=o.substring(1); }
        return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
    }).reduce((p, n) => p ? p : n, 0);

  export const sortDateAsc = (x,y) => {
      return (new Date(x) - new Date(y))
  }

  export const listItems = (items) => {
    if (items) {
        return items.join(", ")
    } else return [];
 }

 export const packData = (formData, data, values) => {
    if (data.content) formData.append('content', data.content);
    if (data.hook) formData.append('hook', data.hook);

 }
  
 export const emptyCart = () => {
    if (typeof window !== "undefined") {
        if (localStorage.getItem("jwt")) {
            var jwt = JSON.parse(localStorage.getItem("jwt"));
            jwt.user.cartCount = 0
            ;
            localStorage.setItem("jwt", JSON.stringify(jwt));
        }      
    }  
};

 export const addToCart = (productId, qty, next) => {
    const { user, token } = AuthenticatedUser();  

    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');
    
    return fetch(`${API}/addToCart/${user._id}/${user._id}`, {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify({productId: productId, quantity: qty})
    })
    .then((response) => response.json())
    .then((responseJSON) => {
            if (typeof window !== "undefined") {
                if (localStorage.getItem("jwt")) {
                    var jwt = JSON.parse(localStorage.getItem("jwt"));
                    var newCartCount = responseJSON;
                    jwt.user.cartCount = newCartCount;
                    localStorage.setItem("jwt", JSON.stringify(jwt));
                    toast.success("Item added to Cart");
                } 
                else toast.info("To shop, please login");  
            }  

            next();
        })
        .catch(err => {
            console.log(err)
            toast.error(err);  

            next();
        });
};

export const removeFromCart = (itemId, next) => {
    const { user, token } = AuthenticatedUser();

    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');
    //myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    
    return fetch(`${API}/removeFromCart/${user._id}/${user._id}`, {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify({ itemId: itemId})
    })
    .then((response) => response.json())
    .then((responseJSON) => {
            toast.error("Item Removed from Cart");

            if (typeof window !== "undefined") {
                if (localStorage.getItem("jwt")) {
                    var jwt = JSON.parse(localStorage.getItem("jwt"));
                    var newCartCount = responseJSON;
                    jwt.user.cartCount = newCartCount;
                    localStorage.setItem("jwt", JSON.stringify(jwt));
                }      
            }  
            next();
        })
        .catch(err => {
            console.log(err)
            next();
        });
};

function getShipping(cartItems) {
    if (!cartItems || !cartItems.length) return 0;

    return cartItems.reduce((currentValue, nextValue) => {
        if (!nextValue.quantity || !nextValue.product) return currentValue;
        return currentValue + nextValue.quantity * (nextValue.product.shippingCost?nextValue.product.shippingCost:0);
    }, 0);
};

function getTotal(cartItems) {
    if (!cartItems || !cartItems.length) return 0;

    return cartItems.reduce((currentValue, nextValue) => {
        if (!nextValue.quantity || !nextValue.product || !nextValue.product.myPrice) return currentValue;
        return currentValue + nextValue.quantity * nextValue.product.myPrice;
    }, 0);
};

export const computeCart = (cart) => {

    const shipping = getShipping(cart);
    const subtotal = getTotal(cart);
    const total = subtotal+shipping;

    return {shipping: shipping, subtotal: subtotal, total: total}
}

export const stopTimer = () => {
    setTimeout(function() {
        document.querySelector(".loader-wrapper").style = "display: none";
    }, 100); 
}

export const isValid = (value, letterCount) => {
    if (typeof value === 'undefined') return false;

    const val = value.trim();
    if (letterCount && val.length < letterCount) return false;
    return !( value === "" || !  /$/.test(value))
}

export const isValidPhone = (phone) => {
    var regex = /((\(\d{3}\)?)|(\d{3}))([\s-./]?)(\d{3})([\s-./]?)(\d{4})/;
    return !( phone === "" || ! regex.test(phone))
}

export const isValidEmail = (email) => {
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/;
    //var regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    return !( email === "" || ! regex.test(email))
}

export const isValidPassword = (password) => {
    if (typeof password === 'undefined') return false;

    if (password && password.length < 4) return false;
    
    var regex = /$/;
    return !( password === "" || ! regex.test(password) )
}

export const hasPerm = (user, value) => {
    if (!user) return false;
    if (!user.permissions) return false;
    if (!value) return false;
    return user.permissions.includes(value);
}

export const hasOnePerm = (user, values) => {
    if (!user) return false;
    if (!user.permissions) return false;
    return user.permissions.some(r => values.includes(r))
}

export const isBetweenDates = (dateCheck, dateFrom, dateTo) => {
    const gCheck = dateCheck.getTime();
    const gFrom = dateFrom.getTime();
    const gTo = dateTo.getTime();
    return (gFrom <  gCheck && gCheck < gTo)
}

export const isBeforeDate = (dateCheck, dateFrom) => {
    const gCheck = dateCheck.getTime();
    const gFrom = dateFrom.getTime();
    return (gFrom > gCheck) 
       
}

export const isAfterDate = (dateCheck, dateTo) => {
    const gCheck = dateCheck.getTime();
    const gTo = dateTo.getTime();
    return (gTo < gCheck) 
       
}

export const getDateRangeString = (startDate, endDate) => {
    const start = moment(startDate);
    const stop = moment(endDate);

    var final = '';
    if (start.year() === stop.year()) {
        if (start.month() === stop.month()) {
            final = `${start.format('MMMM D')} - ${stop.format('D, YYYY')}` 
        } else {
            final = `${start.format('MMMM D')} - ${stop.format('MMMM D, YYYY')}` 
        }
    } else {
        final = `${start.format('MMMM D, YYYY')} - ${stop.format('MMMM D, YYYY')}` 
    }

    return final;
}

export const getDateTimeRangeString = (startDate, endDate) => {
    const start = moment(startDate);
    const stop = moment(endDate);

    var final = '';
    if (start.year() === stop.year()) {
        if (start.month() === stop.month()) {
            final = `${start.format('MM/DD hh:mma')} - ${stop.format('hh:mma')}` 
        } else {
            final = `${start.format('MM/DD hh:mma')} - ${stop.format('hh:mma')}` 
        }
    } else {
        final = `${start.format('MM/DD hh:mma')} - ${stop.format('hh:mma')}` 
    }

    return final;
}

/*
$primary-color: #5d7227 ;
$secondary-color: #a9be73 ;
$success-color: #4c9447  ;
$info-color   : #3e7fa0  ;
$warning-color: #b48c50;
$danger-color: #965b5b ;
*/      
export const colors = ["#A93226","#CB4335","#884EA0","#7D3C98","#2471A3","#2E86C1","#17A589","#138D75","#229954",
"#28B463","#D4AC0D","#D68910","#CA6F1E","#BA4A00","#D0D3D4","#A6ACAF","#839192","#707B7C", "#2E4053","#273746"]

// auth

export const subscribe = user => {
    return fetch(`${API}/subscribe`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(user)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
            console.log(err);
        });
};

export const register = user => {
    return fetch(`${API}/register`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(user)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
            console.log(err);
        });
};


export const signin = user => {
    return fetch(`${API}/signin`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(user)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
    });
};

export const authenticate =     (data, next) => {
    if (typeof window !== "undefined") {
        localStorage.setItem("jwt", JSON.stringify(data));
        next();
    }
};

export const clearLocalJwt = () => {
    if (typeof window !== "undefined") {
        localStorage.removeItem("jwt");
    }
}
export const signout = () => { 
    if (typeof window !== "undefined") {
        const result = callAPI('signout'); 
        localStorage.removeItem("jwt");
        return result;
    }
};

export const userPref = (name) => {
    const jwt = AuthenticatedUser();
    if (jwt && jwt.user && jwt.user.preferences) return jwt.user.preferences[name];
    else return null;
};

export const AuthenticatedUser = () => {
    if (typeof window !== "undefined" && localStorage.getItem("jwt")) {
        const jwt = JSON.parse(localStorage.getItem("jwt"));
        if (jwt.user) { jwt.user.isLoggedIn = true; return jwt; }
    }   

    return {
        token: "blankToken",
        user: {
            email: 'a@b.com',
            name: 'generic user',
            displayname: '',
            _id: '0',
            isMember: false,
            isLoggedIn: false,
        }
    }
};
/*
personnel email = can go through cognos and pull from db
compliant with banner 9 ellucian support
11 can take hlc doc in pdf upload in cognos
query tracing
modio audit
spatial eatures
*/

export const isClientAuthenticated = () => {
    if (typeof window == "undefined") {
        return false;
    }
    return (localStorage.getItem("jwt"));
};

export const isAuthenticated = () => { return callAPI(`isAuth`) };
export const isLoggedIn = () => {
    if (typeof window !== "undefined" && localStorage.getItem("jwt")) {
        const jwt = JSON.parse(localStorage.getItem("jwt"));
        if (jwt.user) { 
            if (!jwt.user) return false;
            if (!jwt.user.permissions) return false;
            return jwt.user.email !== 'a@b.com';
        }
    } 
    return false;
}

export const isAdmin = () => { 
    if (typeof window !== "undefined" && localStorage.getItem("jwt")) {
        const jwt = JSON.parse(localStorage.getItem("jwt"));
        if (jwt.user) { 
            if (!jwt.user) return false;
            if (!jwt.user.permissions) return false;
            return jwt.user.permissions.includes("ADMIN");
        }
    } 
    return false;
};

export const isMember = () => {
    const jwt = AuthenticatedUser();
    return jwt.user.isMember;
};

export const refreshUser = (olduser) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});
    myHeaders.append('Content-Type', 'application/json');

    return fetch(`${API}/user/refresh/${olduser._id}/${user._id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
    });
}

export const putToast = toast;

export const downloadFile = (fileId) =>
{
    executeOnSignedGetUrl(fileId).then(signedURL => {
        window.open(signedURL.url);
    });
}


export const generateWarning = (pid) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});

    return fetch(`${API}/generateWarning/${pid}/${user._id}`, {
        method: 'GET',
        headers: myHeaders,
    })
    .then(response => {
        return response.json()        
    })
    .catch(err => {
        return err;
    })
}

export const generateTournament = (pid) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});

    return fetch(`${API}/generateTournament/${pid}/${user._id}`, {
        method: 'GET',
        headers: myHeaders,
    })
    .then(response => {
        return response.json()        
    })
    .catch(err => {
        return err;
    })
}

export const getJudgeConflicts = (pid, userId) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});

    return fetch(`${API}/tournamentPage/judgeConflicts/${pid}/${userId}/${user._id}`, {
        method: 'GET',
        headers: myHeaders,
    })
    .then(response => {
        return response.json()        
    })
    .catch(err => {
        return err;
    })
}

export const getCompetitors = (pid) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});

    return fetch(`${API}/tournamentPage/competitors/${pid}/${user._id}`, {
        method: 'GET',
        headers: myHeaders,
    })
    .then(response => {
        return response.json()        
    })
    .catch(err => {
        return err;
    })
}

export const getJudges = (pid) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});

    return fetch(`${API}/tournamentPage/judges/${pid}/${user._id}`, {
        method: 'GET',
        headers: myHeaders,
    })
    .then(response => {
        return response.json()        
    })
    .catch(err => {
        return err;
    })
}

export const executeOnSignedGetUrl = (fileId) => {
    const { user, token } = AuthenticatedUser();
    var myHeaders = new Headers({ Accept: "application/json", Authorization: `Bearer ${token}`});

    return fetch(`${API}/sign-s3Get/${user._id}?fileId=${fileId}`, {
        method: 'GET',
        headers: myHeaders,
    })
    .then(response => {
        return response.json()        
    })
    .catch(err => {
        return err;
    })
}
/*
function setProgress(percent, statusLabel)
{    
  var progress = document.querySelector('.percent');
  progress.style.width = percent + '%';
  //progress.textContent = `   ${percent}%   `;
  document.getElementById('progress_bar').className = 'loading';
  document.getElementById('status').innerText = `${statusLabel}  [${percent}%]`;;
}
*/

export const encode = (html) => {
    return btoa(html);
    /*
    var utf8 = html.getBytes("UTF8");
    return new String(new Base64().encode(utf8));
    */
}

export const decode = (base64) => {
    return atob(base64);
    /*
    var dec = new Base64().decode(base64.getBytes());
    return new String(dec , "UTF8");
    */
}


export const dbQuery = (query) => {
    const { user, token } = AuthenticatedUser();

    return fetch(`${API}/query/${user._id}?qid=${query}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
};


export const getBraintreeClientToken = () => {
    const { user, token } = AuthenticatedUser();

    return fetch(`${API}/braintree/getToken/${user._id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};


export const processPayment = (paymentData) => {
    const { user, token } = AuthenticatedUser();

    return fetch(`${API}/braintree/payment/${user._id}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(paymentData)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const processPayPalPayment = (paymentData) => {
    const { user, token } = AuthenticatedUser();

    return fetch(`${API}/paypal/payment/${user._id}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(paymentData)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const processRecurringPayment = (paymentData) => {
    const { user, token } = AuthenticatedUser();

    return fetch(`${API}/braintree/recurringPayment/${user._id}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(paymentData)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const createOrder = (createOrderData) => {
    const { user, token } = AuthenticatedUser();

    return fetch(`${API}/order/create/${user._id}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ order: createOrderData })
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

// Get Unique Brands from Json Data
export const getBrands = (products) => {
    var uniqueBrands = [];
    products.forEach((product) => {
        if (product.tags) {
            product.tags.forEach((tag) => {
                if (uniqueBrands.indexOf(tag) === -1) {
                    uniqueBrands.push(tag);
                }
            })
        }
    })
    //console.log(uniqueBrands)
    return uniqueBrands;
}

// Get Categories from Json Data
export const getCombinedTags = (items) => {
    var tags = [];
    items.forEach((item) => {
        if (item.tags) {
            item.tags.forEach((tag) => {
                if (tags.indexOf(tag) === -1) {
                    tags.push(tag);
                }
            })
        }
    })
    return tags.sort();
}

// Get Unique Colors from Json Data
export const getColors = (products) => {
    var uniqueColors = [];
    products.forEach((product, index) => {
        if(product.colors) {
            product.colors.forEach((color) => {
                if (uniqueColors.indexOf(color) === -1) {
                    uniqueColors.push(color);
                }
            })
        }
    })
    //console.log(uniqueBrands)
    return uniqueColors;
}

// Get Minimum and Maximum Prices from Json Data
export const getMinMaxPrice = (products) => {
    let min = 100, max = 1000;

    products.forEach((product) => {
        let v = product.price;
        min = (v < min) ? v : min;
        max = (v > max) ? v : max;
    })

    return {'min':min, 'max':max};
}


export const getCartTotal = cartItems => {
    var total = 0;
    for(var i=0; i<cartItems.length; i++){
        total += parseInt(cartItems[i].qty, 10)*parseInt((cartItems[i].price*cartItems[i].discount/100), 10);
    }
    return total;
}

// Get Trending Tag wise Collection
export const getTrendingTagCollection = (products, type, tag) => {
    const items = products.filter(product => {
        return product.category === type && product.tags.includes(tag);
    })
    return items.slice(0,8)
}

// Get Trending Collection
export const getTrendingCollection = (products, type) => {
    const items = products.filter(product => {
        return product.category === type;
    })
    return items.slice(0,8)
}

// Get Special 5 Collection
export const getSpecialCollection = (products, type) => {
    const items = products.filter(product => {
        return product.category === type;
    })
    return items.slice(0,5)
}

// Get TOP Collection
export const getTopCollection = products => {
    const items = products.filter(product => {
        return product.rating > 4;
    })
    return items.slice(0,8)
}

// Get New Products
export const getNewProducts = (products, type) => {
    const items = products.filter(product => {
        return product.new === true && product.category === type;
    })

    return items.slice(0,8)
}

// Get Related Items
export const getRelatedItems = (products, type) => {
    const items = products.filter(product => {
        return product.category === type;
    })

    return items.slice(0,4)

}

// Get Best Seller Furniture
export const getBestSellerProducts = (products, type) => {
    const items = products.filter(product => {
        return product.sale === true && product.category === type;
    })

    return items.slice(0,8)
}

// Get Best Seller
export const getBestSeller = products => {
    const items = products.filter(product => {
        return product.sale === true;
    })

    return items.slice(0,8)
}

// Get Mens Wear
export const getMensWear = products => {
    const items = products.filter(product => {
        return product.category === 'men';
    })

    return items.slice(0,8)
}

// Get Womens Wear
export const getWomensWear = products => {
    const items = products.filter(product => {
        return product.category === 'women';
    })

    return items.slice(0,8)
}

// Get Single Product
export const getSingleItem = (products, id) => {

    const items = products.find((element) => {
        return element.id === id;
    })
    return items;
}


export const genderValues = (id) => {
    return {
      male: 'Male',
      female: 'Female',                        
    }[id]
  }

export const judgeClassValues = (id) => {
    return {
        guest: 'Guest',
        competitor: 'Competitor',
        alumni: 'Alumni',
        parent: 'Parent of Competitor',                        
        community: 'Community Judge',
    }[id]
  }

export const experienceValues = (id) => {
    return {
      u01: '0',
      r01: '1 - 2',                        
      r03: '3 - 4',
      o04: '5 and above'
    }[id]
  }

export const ageGroupValues = (id) => {
    return {
      u13: '12 and younger',
      r13: '13 - 14',                        
      r15: '15 - 16',
      r17: '17 - 19',
      r20: '20 - 27',                        
      r28: '28 - 37',
      r38: '38 - 57',
      o57: '58 and above',
    }[id]
  }
  